import { Component, Emit, Vue, Watch } from 'vue-property-decorator';
import { Prop } from 'vue-property-decorator';

@Component({})
export default class ConfirmLinkInduction extends Vue {
  @Prop() isShow!: boolean;
  @Prop() warningMessage!: string;
  isShowData = false;

  private closeModal(): void {
    this.$bvModal.hide('sortModal');
    this.isShowData = false;
  }
  @Emit('acceptBtn')
  private accept(): void {
    this.closeModal();
    return;
  }

  @Emit('exitBtn')
  private exit(): void {
    this.closeModal();
    return;
  }

  @Watch('isShow')
  isShowWatcher(): void {
    this.isShowData = this.isShow;
  }

  render() {
    return (
      <div>
        {/* CANCEL MODAL */}
        <b-modal
          id="confirm-link-induction"
          v-model={this.isShowData}
          centered
          size="md"
          no-close-on-backdrop={true}
          hide-footer
          hide-header
        >
          <p class="text-center gray-small-text mt-3 mb-0">{this.warningMessage}</p>
          <b-container fluid class="pt-5">
            <b-row class="h-100">
              <b-col cols="6" class="d-flex justify-content-center">
                <b-button onClick={() => this.exit()} class="exit-btn ">
                  いいえ
                </b-button>
              </b-col>
              <b-col cols="6" class="d-flex justify-content-center">
                <b-button class="accept-btn" on-click={() => this.accept()}>
                  はい
                </b-button>
              </b-col>
            </b-row>
          </b-container>
        </b-modal>
      </div>
    );
  }
}
